import React, { useEffect, useRef, useState } from 'react';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Wordmark } from './BrandArtwork';
import { navLinks } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false);
        toggleRef.current?.focus();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);
  return <header className="sticky top-0 z-50 border-b border-ink/10 bg-cream" data-id="element-145" data-mp="14ubzhfcn8w7n">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between px-5 md:px-8 lg:px-10" data-id="element-146" data-mp="zwk60gwcp21c">
        <a href="#top" className="-m-2 inline-flex items-center p-2" aria-label="Black Comet Labs — back to top" data-id="element-147" data-mp="2ga0qqiwxkhe9">
          <Wordmark className="h-6 w-auto md:h-7" data-id="element-148" data-mp="29kbrjew3skoj" />
        </a>

        <div className="hidden items-center gap-10 md:flex" data-id="element-149" data-mp="29lwpzfljgnro">
          <nav aria-label="Primary" data-id="element-150" data-mp="2ehlqbl5du8p1">
            <ul className="flex items-center gap-8" data-id="element-151" data-mp="2ekq1x3l6g6pq">
              {navLinks.map(link => <li key={link.href} data-id="element-152" data-mp="2jfwxtp87g743">
                  <a href={link.href} className="text-[14px] font-medium text-ink/70 transition-colors duration-150 ease-out hover:text-ink" data-id="element-153" data-mp="2ohmcdeumz2wx">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <a href="#lab" className="inline-flex min-h-[44px] items-center gap-2 rounded-[2px] bg-ink px-5 text-[14px] font-medium text-cream transition-colors duration-150 ease-out hover:bg-ink/85" data-id="element-154" data-mp="20qqd5wnup5fn">
            Explore our apps
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="1d1o07245w0rh" />
          </a>
        </div>

        <button ref={toggleRef} type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-menu" className="-mr-2 inline-flex h-11 w-11 items-center justify-center rounded-[2px] text-ink md:hidden" data-id="element-156" data-mp="150yh6vvkxex6">
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-157" data-mp="19szos4hsyhgv" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-158" data-mp="m1ua3snllv85" />}
          <span className="sr-only" data-id="element-159" data-mp="m46xilc4kxsl">{open ? 'Close menu' : 'Open menu'}</span>
        </button>
      </div>

      <div id="mobile-menu" hidden={!open} className="border-t border-ink/10 bg-cream md:hidden" data-id="element-160" data-mp="w0jt5or8dlpz">
        <nav aria-label="Primary mobile" data-id="element-161" data-mp="r1gmjzvlr7fw">
          <ul className="mx-auto max-w-content px-5" data-id="element-162" data-mp="r0nnll2vxm8b">
            {navLinks.map(link => <li key={link.href} className="border-b border-ink/10" data-id="element-163" data-mp="27enn4uxtj9v1">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-4 font-display text-xl font-medium text-ink" data-id="element-164" data-mp="22gvqxoq551l1">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <div className="mx-auto max-w-content px-5 py-5" data-id="element-165" data-mp="21089pasp5rce">
          <a href="#lab" onClick={() => setOpen(false)} className="inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-[2px] bg-ink px-5 text-[15px] font-medium text-cream" data-id="element-166" data-mp="211t32x39z48o">
            Explore our apps
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-167" data-mp="2xp7koxko178a" />
          </a>
        </div>
      </div>
    </header>;
}